routes.$inject = ['$stateProvider'];

export default function routes($stateProvider) {

    $stateProvider.state('main.outsideApp', {
        url: '/outsideApp/:token/:panelUserId',
        controller: ['ApiAccountService', 'CookiesService', '$stateParams', '$state', function (ApiAccountService, CookiesService, $stateParams, $state,) {
            CookiesService.setCookie('token', $stateParams.token);
            ApiAccountService.getUserDetails();
            $state.go('main.panel.control', {id: $stateParams.panelUserId});
        }]
    })
}


/** WEBPACK FOOTER **
 ** ./src/main/outsideApp/routes.js
 **/